import API from 'core/api'

export default {

	namespaced: true,

	modules: {},

	state: {},

	getters: {},

	mutations: {},

	actions: {

		generic: function(context, data) {

			data = data || {}
			data.params = data.params || {}

			if (data.params.page) {

				data.params.knownUsers = context.rootGetters['data/users/index']

			}

			return new Promise(function(resolve, reject) {

				API.request(data.url, data.params, true).then(function(json) {

					// add reference data
					context.commit('data/players/add', json.data.players, { root: true })
					context.commit('data/locations/add', json.data.locations, { root: true })
					context.commit('data/users/add', json.data.users, { root: true })
					context.commit('data/games/add', json.data.games, { root: true })
					context.commit('data/families/add', json.data.designers, { root: true })
					context.commit('data/designers/add', json.data.designers, { root: true })
					context.commit('data/languages/add', json.data.languages, { root: true })
					context.commit('data/publishers/add', json.data.publishers, { root: true })
					context.commit('data/artists/add', json.data.artists, { root: true })
					context.commit('data/mechanics/add', json.data.mechanics, { root: true })
					context.commit('data/subdomains/add', json.data.subdomains, { root: true })
					context.commit('data/categories/add', json.data.categories, { root: true })
				
					// first page, replace plays
					if (json.page === 1) {

						context.commit('page/plays/set', json.plays, { root: true })
						context.commit('data/tags/set', json.data.tags, { root: true })
						context.commit('data/tagFamilies/set', json.data.tagFamilies, { root: true })
						context.commit('data/views/set', json.data.views, { root: true })

					// otherwise paginate
					} else {

						context.commit('page/plays/append', json.plays, { root: true })

					}

					context.commit('ready', null, { root: true })

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})		

		},

		users: function(context, params) {

			params.filter = context.rootGetters['filter/plays']

			return context.dispatch('generic', {
				params: params,
				url: 'users/plays'
			})	
			
		},

		groups: function(context, params) {

			params.filter = context.rootGetters['filter/plays']

			return context.dispatch('generic', {
				params: params,
				url: 'groups/plays'
			})	
			
		},

		buddies: function(context, params) {

			params.filter = context.rootGetters['filter/plays']

			return context.dispatch('generic', {
				params: params,
				url: 'buddies/plays'
			})	
			
		}

	}

}